import DataSourcesAccessTable from 'pages/InternalAdmin/organization/pages/DataIngestion/DataSourcesAccessTable';
import ListViewTable from 'components/Common/ListViewTable';
import PageHeader from 'components/Common/PageHeader';
import React from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import { HButton } from 'BaseComponents';
import { PRODUCT } from 'utils/appConstants';
import { StyledGrid } from 'components/IAM/Admin/StyledComponents';
import { crumbs } from 'components/Common/BreadcrumbsNavigation';
import {
  fetchAllImportSources,
  fetchOrgImportSources,
  updateOrgImportSources,
} from 'pages/InternalAdmin/organization/DataIn/redux/actions';
import { useDispatch, useSelector } from 'react-redux';


const DataSourceAccess = () => {
  const dispatch = useDispatch();
  const orgID = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const [sources, updateSources] = React.useState([]);
  const list = useSelector(state => state.internalAdmin
    .organization.dataInAdmin.allImportDataSources);
  const selectedList = useSelector(state => state.internalAdmin
    .organization.dataInAdmin.orgImportDataSources);

  React.useEffect(() => {
    dispatch(fetchAllImportSources());
    dispatch(fetchOrgImportSources(orgID));
  }, [dispatch, orgID]);

  React.useEffect(() => {
    if (Array.isArray(selectedList)) updateSources(selectedList.map(i => i.id));
  }, [selectedList]);

  const onSubmit = () => {
    const payload = {
      dataSourceIDs: sources,
    };
    dispatch(updateOrgImportSources(orgID, payload));
  };


  return (
    <>
      <PageHeader
        title={`${PRODUCT.DATA_CONNECTION.name}s: Manage Import Data Sources Supported`}
        breadcrumbs={[crumbs.helium, crumbs.internalAdmin]}
      />
      <Grid container spacing={0} direction='column'>
        <Grid item>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ListViewTable list={list}>
                    <DataSourcesAccessTable
                      list={list}
                      sources={sources}
                      updateSources={updateSources}
                    />
                  </ListViewTable>
                </Grid>
                <StyledGrid item xs={12}>
                  <HButton
                    color='primary'
                    size='small'
                    variant='contained'
                    onClick={() => onSubmit()}
                  >
                    Update Import Sources
                  </HButton>
                </StyledGrid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default DataSourceAccess;
